module.exports = __webpack_public_path__ + "img/certificate.17fe1553.png";